import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { combineReducers } from "redux";

const namespacers = {
    adminProcurementDashboard: createNamespacer("ADMIN_PROCUREMENT_DASHBOARD"),
}

const initialState = {
    totalUsers: 0,
    totalProjects: 0,
    totalPackages: 0,
    totalSpools: 0,
    shippedSpools: 0,
    inProgressSpools: 0,
    isLoading: false
}

const adminProcurementDashboardReducer = createReducer(initialState, {
    [namespacers.adminProcurementDashboard("FETCH_DATA")]: (state, action) => {
        return {
            ...state,
            totalUsers: action.payload.total_users,
            totalProjects: action.payload.total_projects,
            totalPackages: action.payload.total_packages,
            totalSpools: action.payload.total_spools,
            shippedSpools: action.payload.shipped_spools,
            inProgressSpools: action.payload.in_progress_spools
        }
    },
    [namespacers.adminProcurementDashboard("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value
        }
    },
})

const reducer = combineReducers({
    adminProcurementDashboard: adminProcurementDashboardReducer,
})

export default reducer;